import { SystemRegisterNavigatorInterest } from '@/service';
/**
 * @class @name RegisterNavigatorInterest
 * @description Exposes menu store module
 */
export default class RegisterNavigatorInterest {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name registerInterest
			 * @param {function} commit
			 */
			async registerInterest({ commit }, payload) {
				return SystemRegisterNavigatorInterest.post(payload);
			}
		};
	}
}
